module.exports = __webpack_public_path__ + "img/UTDEAD-2.5bbadbc3.jpg";